import { HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { TenantDto } from '@nusign/picflow-backend-types';
import { getAllRouteParams } from '../../lib/get-all-route-params';
import { BrowserService } from '../../services/browser.service';
import { GalleryService } from '../../services/gallery.service';
import { PublicTenantService } from '../../services/public-tenant.service';
import { RedirectService } from '../../services/redirect.service';
import { StateService } from '../../services/state.service';

@Injectable({
  providedIn: 'root',
})
export class TenantPublicGuard {
  private publicTenantService = inject(PublicTenantService);
  private browserService = inject(BrowserService);
  private redirectService = inject(RedirectService);
  private galleryService = inject(GalleryService);
  private state = inject(StateService);

  async canActivate(next: ActivatedRouteSnapshot): Promise<UrlTree | boolean> {
    const tenantPath = this.browserService.getTenantSubDomain();
    const customDomain = this.browserService.getTenantCustomDomain();

    try {
      let tenant: TenantDto;

      if (customDomain) {
        tenant = await this.publicTenantService.getTenantFromCustomDomain(customDomain);
      } else if (tenantPath) {
        tenant = await this.publicTenantService.getTenant(tenantPath);
      } else {
        // This won't be possible in the future, but for now we need to support it
        const params = getAllRouteParams(next);
        const galleryPathOrId = params.galleryPath || params.galleryId;
        if (galleryPathOrId) {
          const gallery = await this.galleryService.getPublicGalleryFromSnapshot(next);
          if (gallery?.tenant) {
            tenant = gallery.tenant as TenantDto;
          }
        }
      }

      if (tenant && !tenant?.block_public_link_access) {
        this.state.visitingTenant = tenant;
        return true;
      }
      // eslint-disable-next-line no-debugger
      debugger;
      return this.redirectService.externalRedirectTo(this.browserService.getCorrectPicflowUrl());
    } catch (error) {
      if (!(error instanceof HttpErrorResponse)) throw error;
      if (error.status !== 503) throw error;
      return this.redirectService.redirectTo(['maintenance']);
    }
  }
}
